import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Pin = (props) => (
  <Icon viewBox="0 0 17 17" {...props}>
    <g>
      <g fill="currentColor">
        <path d="M8.588 2.495l.773.773-1.435 1.435H5.431L3.422 6.712l3.135 3.113L.83 15.46l.618.618 5.727-5.636 3.113 3.135 2.01-2.01V9.075l1.434-1.435.773.773L17 5.917 11.083 0 8.588 2.495zm5.917 4.68l-.773-.772-2.318 2.296v2.495l-1.126 1.125-5.607-5.607 1.125-1.126h2.495l2.318-2.318-.794-.773 1.258-1.259 4.68 4.68-1.258 1.26z"
        />
        <path d="M10.086 7.207l2.121-2.121.707.707-2.121 2.121z" />
      </g>
    </g>
  </Icon>
);
/*eslint-enable */

export default Pin;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Pin.js